<div
  backButton
  class="group flex cursor-pointer items-center gap-2"
  [defaultBackUrl]="defaultUrl"
  [forceDefault]="forceDefault">
  <tui-icon class="text-foreground-quaternary transition group-hover:text-text-tertiary" icon="@tui.chevron-left" />
  <p class="font-medium text-tertiary transition-all group-hover:ml-1 group-hover:text-text-tertiary">
    {{ label }}
  </p>
</div>
